import type { FormArray } from '@angular/forms';

import { isNullish } from '@plugins/shared/utils/assertFunctions';

import type { CustomControl } from './types';

export const validatePermissionKeysUnique = (
  formArray: FormArray<CustomControl>,
) => {
  const currentValues = formArray
    .getRawValue()
    .map(({ code }) => code?.trim())
    .filter(Boolean);
  let hasError = false;
  formArray.controls.forEach((permissionControl) => {
    const value = permissionControl.controls.code.value;
    if (isNullish(value)) return;

    const duplicated =
      currentValues.filter((text) => text === value.trim()).length > 1;
    if (duplicated) {
      permissionControl.controls.code.setErrors({
        ...permissionControl.errors,
        unique: true,
      });
      hasError = true;
      if (permissionControl.controls.code.pristine) {
        permissionControl.controls.code.markAsTouched();
      }
      return;
    }
    permissionControl.controls.code.updateValueAndValidity({
      emitEvent: true,
      onlySelf: true,
    });
  });
  return hasError ? { unique: true } : null;
};
